


















import { defineComponent, reactive, SetupContext, computed, onMounted, toRef, toRefs, watch } from "@vue/composition-api";
import http from "../../plugins/http";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";

interface Data {
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "drop-area": DropArea,
  },
  setup(props, context: SetupContext) {

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      errors: [],
    });

    /******************************
     * 戻るボタン押下
     ******************************/

    const goBack = (): void => {
      context.root.$router.go(-1);
    };

    /******************************
     * アップロードAPI
     ******************************/

    const upload = async (file: any): Promise<void> => {

      state.errors = []

      let fd = new FormData();
      fd.append('upload[file]', file[0]);

      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      state.errors = [];
      await http.post("/api/ikkatsu_correct_image_upload/upload", fd).then(response => {
        alert("アップロードが完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    return {
      ...toRefs(state),
      goBack,
      upload,
    };
  },
})
